import type { PumsemSearchParams } from '../model/pumsem.type';

/**
 * Pumsem 도메인 Query Key 팩토리.
 *
 * `edition` 을 모든 키에 넣는다. 판이 다르면 **내용이 다른 문서**다 —
 * 키를 공유하면 판을 바꾼 순간 옛 판의 표가 새 판 제목 아래 남는다.
 *
 * 검색 키에 파라미터 객체를 그대로 넣지 않고 정규화하는 이유: 같은 조건인데
 * `changedOnly: undefined` 와 `changedOnly: false` 가 다른 키가 되면 캐시가
 * 두 벌로 쪼개진다.
 */
export const pumsemKeys = {
  all: ['pumsem'] as const,
  editions: () => [...pumsemKeys.all, 'editions'] as const,
  searches: () => [...pumsemKeys.all, 'search'] as const,
  search: (params: PumsemSearchParams) =>
    [
      ...pumsemKeys.searches(),
      {
        q: params.q,
        edition: params.edition ?? null,
        division: params.division ?? null,
        resource: params.resource ?? null,
        changedOnly: params.changedOnly ?? false,
        offset: params.offset ?? 0,
      },
    ] as const,
  items: () => [...pumsemKeys.all, 'item'] as const,
  item: (division: string, code: string, edition: string | null) =>
    [...pumsemKeys.items(), division, code, edition] as const,
  diff: (division: string, code: string, edition: string | null) =>
    [...pumsemKeys.all, 'diff', division, code, edition] as const,
};
